<script>
import { onMounted, ref, h, watch } from "vue";

import * as utils from "../utils";

import "@toast-ui/editor/dist/toastui-editor-viewer.css";

const { latexPlugin } = utils;

export default {
  props: {
    text: String,
  },
  setup(props) {
    const viewer = ref();

    let viewerInstance = null;
    let ViewerConstructor = null;
    let isInitializing = false;

    const initViewer = async function () {
      if (!viewer.value) return;

      // If already initialized, just update the markdown
      if (viewerInstance) {
        viewerInstance.setMarkdown(props.text || "");
        return;
      }

      // Prevent concurrent initialization
      if (isInitializing) return;
      isInitializing = true;

      try {
        if (!ViewerConstructor) {
          const module = await import(
            "@toast-ui/editor/dist/toastui-editor-viewer"
          );
          ViewerConstructor = module.default || module;
        }

        if (!viewer.value) {
          isInitializing = false;
          return;
        }

        viewer.value.innerHTML = "";

        viewerInstance = new ViewerConstructor({
          el: viewer.value,
          initialValue: props.text ? props.text : "",
          customHTMLRenderer: {
            link(node, context) {
              const attributes = {};
              if (node.destination.indexOf("ns:") === 0) {
                attributes["data-person-id"] = node.destination;
                attributes.rel = "popover";
                attributes.href = "javascript:void(0)";
              } else if (
                node.destination.indexOf("#rcref-") === 0 ||
                node.destination.indexOf("#rcauthor-") === 0 ||
                node.destination.indexOf("#rccompany-") === 0 ||
                node.destination.indexOf("#rcpatent-") === 0
              ) {
                attributes["data-rc-ref-id"] = node.destination;
                attributes.href = "javascript:void(0)";

                if (node.destination.indexOf("#rcauthor-") === 0) {
                  attributes.rel = "popover-author";
                  if (node.title) {
                    attributes.style = `--avatar-url: url(${node.title});`;
                  }
                } else if (node.destination.indexOf("#rccompany-") === 0) {
                  attributes.rel = "popover-company";
                  if (node.title) {
                    attributes.style = `--avatar-url: url(${node.title});`;
                  }
                } else {
                  attributes.rel = "popover";
                }
              } else {
                attributes.href = node.destination;
                attributes.target = "_blank";
              }
              return {
                type: context.entering ? "openTag" : "closeTag",
                tagName: "a",
                attributes,
              };
            },
          },
          plugins: [latexPlugin],
        });
      } catch (err) {
        // Silent catch
      } finally {
        isInitializing = false;
      }
    };

    onMounted(() => {
      initViewer();
    });

    watch(
      () => props.text,
      () => {
        initViewer();
      },
    );

    return () =>
      h("div", {
        ref: viewer,
        class: "markdown-viewer-container",
      });
  },
};
</script>
